import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormPentagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFormPentagon"><Path d="M10.5287 2.19922C11.4048 1.56268 12.592 1.5628 13.4682 2.19922L20.8646 7.57422C21.7409 8.21083 22.1075 9.33909 21.7728 10.3691L18.9477 19.0654C18.6128 20.0951 17.6526 20.792 16.5697 20.792H7.42715C6.34443 20.7918 5.38399 20.0951 5.04922 19.0654L2.22402 10.3691C1.88941 9.33924 2.25627 8.21087 3.13222 7.57422L10.5287 2.19922Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormPentagon;
